import { SeatingData, SeatingEmailType } from '@maverick/entity';
import { BbiService } from '@maverick/cms';

export const SeatingManager = {
	GetAvailableTimes: async (seatingData: SeatingData): Promise<Array<string> | null> => {
		const response = await BbiService.GetAvailableTimes(seatingData);
		if (response.error || !response.body?.times) {
			return null;
		}

		return response.body.times;
	},

	GetAvailableTimeSlots: async (seatingData: SeatingData): Promise<Array<string> | null> => {
		const response = await BbiService.GetAvailableTimeSlots(seatingData);
		if (response.error || !!response.body?.errorMessage || !response.body?.timeSlots?.length) {
			return null;
		}

		return response.body.timeSlots;
	},

	CreateReservation: async (seatingData: SeatingData): Promise<Partial<{ error: string; partyKey: string }>> => {
		const response = await BbiService.CreateReservation(seatingData);

		if (!!response.body?.errorMessage) {
			return { error: response.body.errorMessage };
		}

		if (response.error || !response.body?.partyKey) {
			return { error: 'An unexpected error has occurred. Please try again.' };
		}

		return { partyKey: response.body.partyKey };
	},

	SendReservationEmail: async (seatingData: SeatingData, type: SeatingEmailType): Promise<boolean> => {
		const response = await BbiService.SendReservationEmail(seatingData, type);
		if (response.error) {
			return false;
		}

		return response.body;
	},

	GetReservation: async (
		locationId: string,
		partyKey: string
	): Promise<Partial<{ error: string; seatingData: SeatingData }>> => {
		const response = await BbiService.GetReservation(locationId, partyKey);

		if (!!response.body?.errorMessage) {
			return { error: response.body.errorMessage };
		}

		if (response.error) {
			return { error: 'An unexpected error has occurred. Please try again later.' };
		}

		const [day, timeSlot] = response.body.reservationDate.split('T');
		const seatingData = new SeatingData({
			PartyKey: response.body.partyKey,
			LocationId: response.body.unitId,
			Guests: response.body.partySize,
			Day: day,
			TimeSlot: timeSlot,

			FirstName: response.body.firstName,
			LastName: response.body.lastName,
			PhoneNumber: response.body.mobileNumber,
			Email: response.body.email,
			Occasion: response.body.occasion,
			SpecialOccasion: response.body.specialOccasion,
		});

		return { seatingData };
	},

	CancelReservation: async (seatingData: SeatingData): Promise<boolean> => {
		const response = await BbiService.CancelReservation(seatingData);

		if (response.error || !!response.body?.errorMessage) {
			return false;
		}

		return true;
	},

	ProfanityCheck: async (firstName: string, lastName: string): Promise<{ first: boolean; last: boolean } | null> => {
		const response = await BbiService.ProfanityCheck(firstName, lastName);

		if (response.error) return null;

		return response.body;
	},
};
